// src/pages/Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Auth } from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login }    = useAuth();
  const navigate     = useNavigate();
  const [form, set]  = useState({ corp_id: '', email: '', password: '' });
  const [err, setErr]  = useState('');
  const [busy, setBusy] = useState(false);

  const onChange = k => e => set(f => ({ ...f, [k]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      const user = await Auth.login(form);
      login(user);
      navigate('/');
    } catch (ex) {
      setErr(ex.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', padding: '1rem' }}>
      <div style={{ background: 'var(--surface)', borderRadius: 14, padding: '2.5rem 2rem', width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: '1.8rem' }}>
          <div style={{ fontSize: '2rem', fontWeight: 700, color: 'var(--accent)' }}>⚡ BizzFlowSuite</div>
          <div style={{ color: 'var(--muted)', fontSize: '.88rem', marginTop: 4 }}>Sign in to your workspace</div>
        </div>

        {err && <div className="alert alert-error">{err}</div>}

        <form onSubmit={submit}>
          <div style={{ marginBottom: '1rem' }}>
            <label>
              Organisation ID
              <input type="number" value={form.corp_id} onChange={onChange('corp_id')}
                placeholder="e.g. 1" required autoFocus />
            </label>
          </div>
          <div style={{ marginBottom: '1rem' }}>
            <label>
              Email
              <input type="email" value={form.email} onChange={onChange('email')}
                placeholder="you@company.com" required />
            </label>
          </div>
          <div style={{ marginBottom: '1.5rem' }}>
            <label>
              Password
              <input type="password" value={form.password} onChange={onChange('password')}
                placeholder="••••••••" required />
            </label>
          </div>
          <button className="btn btn-primary" type="submit" disabled={busy}
            style={{ width: '100%', padding: '.7rem', fontSize: '1rem' }}>
            {busy ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
